export const SessionStorageConstants = {
  PendingToast: 'pendingToast',
  InvitationToken: 'invitationToken',
};
